import React from 'react'
import * as c from '../const'
import InfoPageLayout from '../components/parts/InfoPageLayout'
import {Link} from 'react-router-dom'

const Page404 = () => {
  return (
    <InfoPageLayout meta={c.SEO.page404}>
      <h1 className={`page-404-title`}>404</h1>
      <div className={`font-h4`}>
        Unfortunately, this page does not exist...
      </div>
      <Link className={`btn-primary --big`} to={c.LINK_HOME}>
        Go to Home page
      </Link>
    </InfoPageLayout>
  )
}

export default Page404
